module.exports = __webpack_public_path__ + "img/comparison1.7bd81f3a.png";